import { api, formatParams, config } from "@/utils/axios";

// 获取待办消息条数
export function count(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/flowMsg/count?userId=${params}`,
    })
  );
}

// 清空已读消息
export function deleteByIds(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/flowMsg/deleteByIds`,
    })
  );
}

// 获取待办消息列表
export function list(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/flowMsg/list?userId=${params.userId}`,
    })
  );
}

// 获取待办消息列表
export function listAll(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/flowMsg/listAll?userId=${params.userId}`,
    })
  );
}

// 全部已读
export function updateAllMsg(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/flowMsg/updateAllMsg?userId=${params.userId}`,
    })
  );
}
